export default function login(state = [], action) {


    return state;
}


/** WEBPACK FOOTER **
 ** ./src/reducers/isLoading.js
 **/